import { handleActions, combineActions } from 'redux-actions'
import { combineReducers } from 'redux'

import { pathOr } from 'ramda'

import * as BillingActions from 'modules/billing/actions'
import * as UserActions from 'modules/user/actions'
import * as actions from './actions'

const uniqueHandle = handleActions({
  [actions.checkUniqueHandleFailed]: () => false,
  [actions.checkUniqueHandleSuccess]: () => true,
}, false)

const jobTitle = handleActions({
  [actions.setJobTitle]: (state, action) => action.payload,
}, '')

const companyName = handleActions({
  [actions.setCompanyName]: (state, action) => action.payload,
  [BillingActions.fetchDealSuccess]: (state, action) => pathOr('', ['customerInfo', 'companyName'], action.payload),
  [UserActions.fetchClearbitForEmailSuccess]: (state, action) => action.payload.response.attributes.employment_name || ''
}, '')

const companyUrl = handleActions({
  [actions.setCompanyUrl]: (state, action) => action.payload
}, '')

const handle = handleActions({
  [actions.setHandle]: (state, action) => action.payload,
}, '')

const coverPhotoUrl = handleActions({
  [actions.uploadCoverPhotoSuccess]: (state, action) => action.payload,
}, false)

const isUploadingCoverPhoto = handleActions({
  [actions.uploadCoverPhotoPending]: () => true,

  [combineActions(
    actions.uploadCoverPhotoSuccess,
    actions.uploadCoverPhotoFailed
  )]: () => false
}, false)

const globalHandle = handleActions({
  [actions.fetchProfileSuccess]: (state, action) =>  action.payload.globalHandle,
}, '')

export default combineReducers({
  jobTitle,
  companyName,
  companyUrl,
  handle,
  uniqueHandle,
  coverPhotoUrl,
  isUploadingCoverPhoto,
  globalHandle,
})



// WEBPACK FOOTER //
// ./src/modules/profile/reducer.js